import React, { useEffect, useCallback, useState} from 'react';
import MidiEffectComponent from "components/effects/MidiEffectComponent.js";
import UserScriptEffect from "effects/midi/scripting/UserScriptEffect.js";
import TransformationSelector from './TransformationSelector.js';
import ParameterInput from "components/parameters/ParameterInput.js";
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import Dropdown from 'react-dropdown';
import {
    getTransformRange,
    SCRIPT,
    EXPAND,
    MARKOV,
    DELAY,
    ROLL,
    TRANSPOSE,
    NEEDS_VALUE,
    PROBABILITY,
    EVERY,
    GATE_MASK,
    REVERSE,
    THEN_OPTIONS,
    WHEN_OPTIONS
} from 'pattern/groups/transformations.js';

const colors = new Colors();

const TransformationEditor = ({transformation, sequencerEngine, track, _whenType}) => { 
    let [whenType, setWhenType] = useState(transformation.whenType);
    let [thenType, setThenType] = useState(transformation.thenType);
    let [thenValue, setThenValue] = useState(transformation.thenValue);
    let style = {
        color: colors.getColorForHash(transformation.id)
    };

    useEffect(() => {
        setWhenType(_whenType);
    }, [_whenType, setWhenType]);

    const onChangeWhenType = useCallback((opt) => {
        let value = opt.value;
        transformation.whenType = value;
        setWhenType(value);
    }, [setWhenType, transformation]);


    const onChangeThenType = useCallback((opt) => {
        let value = opt.value;
        transformation.thenType = value;
        if (value === SCRIPT) {
            transformation.midiEffect = new UserScriptEffect(track);
        }
        setThenType(value);
    }, [setThenType, transformation, track]);

    let {min, max, step} = getTransformRange(transformation.thenType);

    return (
        <div className="step-transformation-editor">
          <div className="transformation-header">
            <div style={style} className="transformation-name">
              {transformation.name}
            </div>
            <div className={whenType ? "transformation" : "transformation none"}>
            <Dropdown
              options={WHEN_OPTIONS}
              value={WHEN_OPTIONS.find(x => x.value === whenType)}
              onChange={onChangeWhenType}
              placeholder="When"/>
              {whenType === MARKOV ?
               <ParameterInput className="when-value" placeholder="Value" parameter={transformation.auxValue}/> : 
               <ParameterInput className="when-value" placeholder="Value" parameter={transformation.whenValue}/>}
               <div className="unit-type">{whenType === PROBABILITY || whenType === MARKOV ? "%" : " loops"}</div>
              <Dropdown
                className="action"
                options={THEN_OPTIONS}
                value={THEN_OPTIONS.find(x => x.value === thenType)}
                onChange={onChangeThenType}
                placeholder="Action"/>
            </div>
          </div>
          {NEEDS_VALUE.includes(thenType) ?
           <div className="transformation">
             <EffectParameterSlider root={1} min={min} max={max} step={step} parameter={transformation.thenValue} name="Amount"/>
           </div>: ''}
          {thenType === SCRIPT && transformation.midiEffect ?
           <MidiEffectComponent
             effect={transformation.midiEffect}
             sequencerEngine={sequencerEngine}
             track={track}
           /> : ''}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      _whenType: props.transformation.whenType
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransformationEditor);
